import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import {
  routerReducer as routing,
  routerMiddleware as createRouterMiddleware,
} from 'react-router-redux';
import { reducer as form } from 'redux-form';
import thunkMiddleware from 'redux-thunk';
import { browserHistory } from 'react-router';
import * as reducers from 'state/ducks';

const isProduction = process.env.NODE_ENV === 'production';
const noop = _ => _;

const routerMiddleware = createRouterMiddleware(browserHistory);

const enhancer = client =>
  compose(
    applyMiddleware(thunkMiddleware, client.middleware(), routerMiddleware),
    // Only include the DevTools when not in production
    isProduction ? noop : require('../containers/DevTools').default.instrument() // eslint-disable-line global-require
  );

export default function configureStore(apolloClient, initialState = {}) {
  const rootReducer = combineReducers({
    ...reducers,
    form,
    routing,
    apollo: apolloClient.reducer(),
  });

  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  const store = createStore(rootReducer, initialState, enhancer(apolloClient));

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  /* istanbul ignore if */
  // not sure how to hang the ducks reducers in here.
  // if (!isProduction && module.hot) {
  //   module.hot.accept(
  //     '../reducers',
  //     () => store.replaceReducer(require('../reducers')) // eslint-disable-line global-require
  //   );
  // }

  return store;
}



// WEBPACK FOOTER //
// ./src/state/store/index.js